import { GlobalAlert } from "../reducers/mainReducer";

export const SHOW_LOADER = "SHOW_LOADER";
export const SET_ALERT = "SET_ALERT";

export const showLoader = (isShowing: boolean) => {
  return { type: SHOW_LOADER, value: isShowing }
}

export const setAlert = (error: GlobalAlert | null) => {
  return { type: SET_ALERT, value: error };
}

